import {ErrorPriority} from "../../enums/ErrorPriority";
import {NavigationVisitor} from "../navigation/NavigationVisitor";
import {Tenant} from "../tenant/Tenant";
import {TenantApplication} from "../tenant/TenantApplication";
import {LoggableEntity} from "./LoggableEntity";

export class LogBook extends LoggableEntity {
    private static DESCRIPTION_KEY = "error.name.logBook";

    createdAt: Date;
    runId: string;
    totalAmountOfErrors: number;

    constructor(id: string, tenant: Tenant, application: TenantApplication, createdAt: Date | string, totalAmountOfErrors: number,
                runId: string, errorType: ErrorPriority, isSolved: boolean) {
        super(id, tenant, application, errorType, isSolved);
        this.createdAt = new Date(createdAt);
        this.runId = runId;
        this.totalAmountOfErrors = totalAmountOfErrors;
    }

    public override accept(visitor: NavigationVisitor, openNewTab: boolean = false): void {
        visitor.visitLogBook(this, openNewTab);
    }

    public override get descriptionKey(): string {
        return LogBook.DESCRIPTION_KEY;
    }
}
